import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/business/leads/artifacts/")({
    beforeLoad: ({ search }) => {
        throw redirect({ to: "/sales/leads/artifacts", search, replace: true });
    },
});
